export default __webpack_public_path__ + "static/media/slstmtestloss.caf9bc79.png";